'use client'

import LikeBtn from './like-btn'
import DislikeBtn from './dislike-btn'
import s from '../style.module.scss'
import clsx from 'clsx'
import {abbreviateNumber} from '@app/components/search-section/search-result-card/helper'
import {useGameLiked} from './game-like-provider/game-liked-context'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'
import {useEffect} from 'react'

type Props = {
  className?: string
  gameNameEn: string
  gameCode: string
}

const LikeDislikeButtons = ({className, gameNameEn, gameCode}: Props) => {
  const {handleDislike, handleLike, likeState} = useGameLiked()

  return (
    <div className={clsx(s.buttons_wrapper, className)}>
      <LikeBtn
        handleLike={handleLike}
        isLiked={likeState.likeDislikeStatus === true}
        count={abbreviateNumber(likeState.counts.likeCount)}
      />
      <DislikeBtn
        handleDislike={handleDislike}
        isDisliked={likeState.likeDislikeStatus === false}
        count={abbreviateNumber(likeState.counts.dislikeCount)}
      />
    </div>
  )
}

export default LikeDislikeButtons
